import { render } from "./ServicesDatatableTDCategory.vue?vue&type=template&id=51f67e32"
import script from "./ServicesDatatableTDCategory.vue?vue&type=script&lang=js"
export * from "./ServicesDatatableTDCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__